import React, { Component } from 'react';
import { View, Dimensions, StyleSheet } from 'react-native';

export class ResponsiveLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sizes: {
                large: 1024,
                medium: 640,
            }
        }
    }

    renderChildren = (isUnderThreshold) => {
        const { col, children, margin = 2, aboveThresholdHeight } = this.props;
        const width = `${(100 / col) - margin}%`;
        if (isUnderThreshold) {
            return children;
        }
        return (
            React.Children.map(children, (child, i) => {
                return (
                    <View style={{ width, marginRight: margin, height: aboveThresholdHeight }}>
                        {child}
                    </View>
                )
            })
        )
    }

    render() {
        const { containerStyle, rowStyle, colStyle, thresholdSize } = this.props;
        const { width } = Dimensions.get('window');
        const { sizes } = this.state;
        const isUnderThreshold = width <= sizes[thresholdSize];
        const layoutType = isUnderThreshold ?
            { ...styles.col, ...colStyle } :
            { ...styles.row, ...rowStyle };

        return (
            <View style={[
                styles.container,
                layoutType,
                containerStyle,
            ]}>
                {this.renderChildren(isUnderThreshold)}
            </View>
        );
    }
}
const styles = StyleSheet.create({
    container: {
        justifyContent: 'space-between',
    },
    row: {
        flexWrap: 'wrap',
        flexDirection: 'row',
    },
    col: {
        flexDirection: 'column',
    },
});
